import Customers from './Customers';
import CustomersProvider from './CustomersContext';

let Index = () => {
    return (
        <CustomersProvider>
            <Customers />
        </CustomersProvider>
    )
}

export default Index;